import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import neoSapien from "../../assets/images/home/neosapienWeb.webp";
import neoSapienMobile from "../../assets/images/home/neosapienMobile.webp";
import neosapienTab from "../../assets/images/home/neosapienTablet.webp";

import useScreenMobile from "hooks/useScreenMobile";
import FadeUp from "component/FadeUp/FadeUp";

import "react-lazy-load-image-component/src/effects/blur.css";

const Experience = () => {
  const isMobile = useScreenMobile({ size: 568 });
  const isTab = useScreenMobile({ size: 992 });

  return (
    <section className="container experienceContainer">
      <div className="common-heading">
        <FadeUp>
          <h1>
            Your AI Ally, {isMobile && <br />} <span>At Your Fingertips</span>
          </h1>
        </FadeUp>
        <FadeUp>
          <p>
            Access meeting summaries, make faster decisions, brainstorm with
            your AI ally, and always be prepared.
          </p>
        </FadeUp>
      </div>
      <div className="mobileBox">
        <LazyLoadImage
          src={isTab ? neosapienTab : isMobile ? neoSapienMobile : neoSapien}
          alt="Banner Image"
          effect="blur"
        />
      </div>
    </section>
  );
};

export default Experience;
